/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Utils
import { formatDate, formatDateForPicker } from '@/utils/dateUtils'
import { getAvatarColor } from '@/utils/userUtils'
import {removeDiacritics} from '@/utils/navigateUtils'
import 'quill/dist/quill.core.css' // Required
import 'quill/dist/quill.snow.css' // For snow theme (optional)
import 'quill/dist/quill.bubble.css' // For bubble theme (optional)

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// ↓↓↓ Přidejte import pinia instance z persist.ts ↓↓↓
import pinia from './stores/persist/persist'

// Import a nově vytvořený i18n plugin
import i18n from '@/plugins/i18n'

const app = createApp(App)

app.use(pinia) // Přidejte pinia do aplikace
app.use(i18n) // Zaregistrujte i18n plugin


registerPlugins(app)

app.config.globalProperties.$formatDate = formatDate;
app.config.globalProperties.$formatDateForPicker = formatDateForPicker;
app.config.globalProperties.$removeDiacritics = removeDiacritics;
app.config.globalProperties.$getAvatarColor = getAvatarColor;

app.mount('#app')
